<template>
  <div class="vc-body">
    <div class="vc-body__content">
      <p class="vc-body__text">{{ $t('message.sichernConnect.modal.body.text') }}</p>
      <p class="vc-body__text">{{ $t('message.sichernConnect.modal.bodyNoEmail.description') }}</p>
      <ul class="vc-body__list">
        <li
          v-for="(item, index) in noEmailListItems"
          :key="index"
          class="vc-body__list-item"
        >
          <span class="vc-body__bullet">
            <status-icon status="success" color="#2d2d2d" />
          </span>
          {{ $t(item) }}
        </li>
      </ul>

      <p class="vc-body__text">{{ $t('message.sichernConnect.modal.bodyNoEmail.noEmailText') }}</p>

      <sichern-connect-email-form
        ref="emailForm"
        @update:canSubmit="canSubmit = $event"
      />

      <span v-if="globalErrorMessage" class="vc-body__global-error">
        <status-icon status="error-outlined" size="small" />
        {{ globalErrorMessage }}
      </span>
    </div>

    <div class="vc-body__footer">
      <v-btn
        flat
        outline
        class="vc-btn-secondary"
        color="#4f41a3"
        :disabled="isBusy"
        @click="connection.rememberMeLater()"
      >
        {{ $t('message.sichernConnect.modal.body.disagree') }}
      </v-btn>
      <v-btn
        class="vc-btn-primary white--text"
        color="deep-purple darken-3"
        :disabled="isAcceptDisabled"
        :loading="isLoading"
        @click="handleAccept"
      >
        {{ $t('message.sichernConnect.modal.body.accept') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import StatusIcon from './StatusIcon.vue'
import SichernConnectEmailForm from './SichernConnectEmailForm.vue'
import Users from '@/apiClient/Users'

export default {
  name: 'SichernConnectNoEmailBody',
  components: { StatusIcon, SichernConnectEmailForm },
  inject: {
    connection: {
      default: function () { return { applyLinkAccount: function () {}, closeModal: function () {}, rememberMeLater: function () {} } }
    }
  },
  data () {
    return {
      isLoading: false,
      canSubmit: false,
      noEmailListItems: [
        'message.sichernConnect.modal.bodyNoEmail.list.item1',
        'message.sichernConnect.modal.bodyNoEmail.list.item2'
      ]
    }
  },
  computed: {
    isRequestLoading () {
      return this.$store.state.sichernConnect.isRequestLoading
    },
    isBusy () {
      return this.isLoading || this.isRequestLoading
    },
    isAcceptDisabled () {
      return !this.canSubmit || this.isBusy
    },
    globalErrorMessage () {
      var code = this.$store.state.sichernConnect.apiErrors.globalCode
      if (!code) return ''
      var errorMsg = this.$t('message.selfService.emailForm.' + code)
      if (errorMsg && errorMsg !== 'message.selfService.emailForm.' + code) return errorMsg
      return ''
    }
  },
  mounted () {
    this.$store.dispatch('sichernConnect/clearApiErrors')
  },
  methods: {
    extractErrorCode (error) {
      var data = error && error.response && error.response.data
      if (!data) return null
      if (data.codes && data.codes[0] && data.codes[0].code) return data.codes[0].code
      if (data.response_v2 && data.response_v2.code) return data.response_v2.code
      return null
    },
    async handleAccept () {
      var emailForm = this.$refs.emailForm
      var data = emailForm.validate()
      if (!data) return

      this.$store.dispatch('sichernConnect/clearApiErrors')
      this.isLoading = true
      this.$store.dispatch('sichernConnect/setRequestLoading', true)

      var shouldCloseModal = false
      try {
        var users = new Users()
        await users.changeMail(data.password, data.email)
        await this.connection.applyLinkAccount()
        shouldCloseModal = true
      } catch (error) {
        this.$store.dispatch('sichernConnect/setApiErrorCode', this.extractErrorCode(error))
      } finally {
        this.isLoading = false
        this.$store.dispatch('sichernConnect/setRequestLoading', false)
        if (shouldCloseModal) this.connection.closeModal()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.vc-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 330px;

  &__content {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    text-align: left;
  }

  &__text {
    font-size: 1rem;
    color: #171717;
    margin: 0;
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__list-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
  }

  &__bullet {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  }

  &__global-error {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 1rem;
    font-size: 0.75rem;
    color: #404040;
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
    padding: 1.5rem;
    border-top: 1px solid #e5e7eb;
    background: white;
  }
}

.vc-btn-secondary {
  text-transform: none;
}

.vc-btn-primary {
  text-transform: none;
}
</style>
